module.exports = __webpack_public_path__ + "static/media/delete-message.20174c75.svg";